export const SUBMODULE_NAME = 'overlayAutomation';
